import { render } from "./SettingsPageMenu.vue?vue&type=template&id=59445e42"
import script from "./SettingsPageMenu.vue?vue&type=script&lang=js"
export * from "./SettingsPageMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__